class Nav {
  constructor(el, closeEl) {
    this.el = document.getElementById("jsNav");
    this.btnEl = document.getElementById("jsNavBtn");
    this.closeEl = document.getElementById("jsNavClose");
    this.timer = 100;
    this.timeout = null;
    this.className = "sticky";
    this.Init();
  }

  Init() {
    if (this.btnEl) {
      this.btnEl.addEventListener("click", () => {
        if (this.el.classList.contains("show")) {
          this.el.classList.remove("show");
          this.btnEl.classList.remove("expand");
        } else {
          this.el.classList.add("show");
          this.btnEl.classList.add("expand");
        }
      });
    }
    if (this.closeEl) {
      this.closeEl.addEventListener("click", () => {
        this.el.classList.remove("show");
        this.btnEl.classList.remove("expand");
      });
    }
  }
}

window.addEventListener("load", () => {
  let nav = new Nav();
});
